import Select from "react-select";
import { sortAlphabetically } from "../helper/formatters";

const metrics = [
	{ label: "Total Page views", value: "pageviews" },
	{ label: "Web page views", value: "webpageviews" },
	{ label: "App page views", value: "apppageviews" },
	{ label: "Video page views", value: "videoPageViews" },
	{ label: "Conversions", value: "conversion" },
	{ label: "Total reading time (hrs)", value: "totalReadingTime" }
];

const sortedMetrics = sortAlphabetically(metrics, "label");

type Props = {
	value: string;
	updateConfig: Function;
	isDisabled?: boolean
};

type Option = {
	value: string;
	label: string;
};

const GoalMetricType = (props: Props) => {
	const getType = (value: string) => {
		return sortedMetrics.find((metric: Option) => metric.value === value);
	};

	const handleChange = (option: Option) => {
		props.updateConfig("metricType", option.value);
	};

	return (
		<div className="config-item__selects">
			<div className="form-group">
				<label htmlFor="metricType">Type</label>
				<Select
					id="metricType"
					className="basic-single"
					classNamePrefix="so-select-metric-type"
					isSearchable={true}
					value={
						props.value ? getType(props.value) : sortedMetrics[0]
					}
					options={sortedMetrics}
					onChange={(option) => handleChange(option as Option)}
					menuPortalTarget={document.body}
					styles={{
						menuPortal: (base) => ({ ...base, zIndex: 9999 }),
					}}
					isDisabled={props.isDisabled}
				/>
			</div>
		</div>
	);
};

export default GoalMetricType;
